module.exports = __webpack_public_path__ + "static/img/slide3.d42ff0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slide/slide3.png
// module id = 7lxO
// module chunks = 232